exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".trend-complementary .quote{margin-top:4.0625rem;font-size:28px;font-size:1.75rem}.trend-complementary .bg-icon{right:10%;top:50%}", ""]);

